module.exports = __webpack_public_path__ + "static/img/criminal.7162b63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/criminal.png
// module id = 5szZ
// module chunks = 1 3